/**
 * Helpers for converting between ISO UTC datetime strings (as stored in the
 * backend) and the local <input type="datetime-local"> value format.
 *
 * <input type="datetime-local"> uses the value "YYYY-MM-DDTHH:mm" and always
 * interprets it as the browser's LOCAL timezone. Naively slicing the first 16
 * characters of a UTC ISO string like "2026-01-01T00:00:00Z" ignores the "Z"
 * and treats the value as local time, which shifts the moment by the local
 * offset and produces a different UTC time when re-saved.
 */

// Convert ISO UTC → "YYYY-MM-DDTHH:mm" in local timezone (for datetime-local input)
export const isoToLocalInput = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

// Convert local datetime-local value → ISO UTC string
export const localInputToIso = (val) => {
  if (!val) return null;
  const d = new Date(val); // datetime-local is parsed as local time
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
};

// Human-friendly Swedish label for a sale end date, e.g. "till 15 mars 2026 kl 23:59"
export const formatSaleEndsLabel = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('sv-SE', {
    day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
};
